import styles from "./add-remarks-modal.module.scss";
import locale from "localization";
import { TextField } from "components/commons";
import { ConfirmModal } from "components/modals";
import { useEffect, useState } from "react";
import { FormMode } from "enums";

const AddRemarksModal = ({ fields, shift, pageMode, remarksUgt, setRemarksUgt, ...modal }) => {
  const [textValue, setTextValue] = useState("");
  const isEdit = pageMode === FormMode.Edit;
  const hasValue = isEdit && remarksUgt !== null && remarksUgt !== "";
  const didEdit = hasValue && remarksUgt !== textValue;
  const shiftRemarksUgt = shift.remarksUgt;

  useEffect(() => {
    if (modal.open || shiftRemarksUgt) {
      setTextValue((isEdit ? remarksUgt : shiftRemarksUgt) || "");
    }
  }, [remarksUgt, isEdit, shiftRemarksUgt, modal.open]);

  const handleInputChange = (name, value) => {
    setTextValue(value.value);
  };

  const handleSave = () => {
    setRemarksUgt(textValue);
    modal.close();
  };

  const handleCancel = () => {
    setRemarksUgt(didEdit || hasValue ? remarksUgt : "");
    setTextValue(didEdit || hasValue ? remarksUgt : "");
    modal.close();
  };

  return (
    <ConfirmModal
      {...modal}
      title={
        isEdit
          ? hasValue
            ? didEdit
              ? locale.addRemarks
              : locale.viewRemarks
            : locale.addRemarks
          : locale.viewRemarks
      }
      titleStyle={styles.content}
      hideSecondary={!isEdit || (hasValue && !didEdit)}
      primary={{
        text: isEdit
          ? hasValue
            ? didEdit
              ? locale.saveChanges
              : locale.gotIt
            : locale.saveChanges
          : locale.gotIt,
        disabled: textValue.length === 0,
        onClick: isEdit
          ? hasValue
            ? didEdit
              ? handleSave
              : () => modal.close()
            : handleSave
          : () => modal.close(),
      }}
      secondary={{
        text: locale.cancel,
        onClick: handleCancel,
      }}
    >
      <div className={styles.form}>
        <TextField
          multiline
          placeholder={locale.typeYourRemarks}
          maxLength={300}
          readOnly={!isEdit}
          value={textValue}
          onChange={handleInputChange}
        />
      </div>
    </ConfirmModal>
  );
};

export default AddRemarksModal;
